import { useState } from 'react'
import { Box, Popover } from '@mui/material'
import { SwitchAppButtonProps } from './SwitchAppButton.types'
import { Logo, Pointer } from 'Common/Supplyvue-ui/SwitchAppButton.styles'
// import { ReactComponent as AppSwitchIcon } from '../../assets/icons/appswitch.svg'

export const SwitchAppButton = ({
  logoOne,
  logoTwo,
  handleLogoOneClick,
  handleLogoTwoClick,
  anchorV = 'bottom',
  anchorH = 'center',
  transformV = 'top',
  transformH = 'right',
}: SwitchAppButtonProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null)

  const handleClick = (event: React.MouseEvent<HTMLDivElement>): void => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'appswitch-popover' : undefined

  return (
    <>
      <Pointer
        onClick={(e) => handleClick(e)}
        role="button"
        aria-label="switch app"
      >
        {/* <AppSwitchIcon height='32px' width='32px' /> */}
      </Pointer>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: anchorV,
          horizontal: anchorH,
        }}
        transformOrigin={{
          vertical: transformV,
          horizontal: transformH,
        }}
      >
        <Box display="flex" p={1}>
          <Logo
            onClick={handleLogoOneClick}
            role="button"
            aria-label="logo one"
          >
            <img
              src={logoOne}
              alt="Switch application"
              height="48px"
              width="58px"
            />
          </Logo>
          <Logo
            onClick={handleLogoTwoClick}
            role="button"
            aria-label="logo two"
          >
            <img
              src={logoTwo}
              alt="Switch application"
              height="48px"
              width="80px"
            />
          </Logo>
        </Box>
      </Popover>
    </>
  )
}
